import { render, staticRenderFns } from "./DownloadCenterView.vue?vue&type=template&id=3a625d9e&scoped=true"
import script from "./DownloadCenterView.vue?vue&type=script&lang=js"
export * from "./DownloadCenterView.vue?vue&type=script&lang=js"
import style0 from "./DownloadCenterView.vue?vue&type=style&index=0&id=3a625d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a625d9e",
  null
  
)

export default component.exports